var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"footer-icon",attrs:{"to":"/"}},[_vm._v(" Powered by "),_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/menulingua_logo_final_small.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }